<template>
    <div ref="menuWrap" :class="[{ 'logo-hode': collapseMenu }]">
        <el-menu
            ref="menus"
            unique-opened
            class="menu-content"
            background-color="#fff"
            text-color="#333"
            active-text-color="#2590fa"
            router
            :default-active="activeMenu"
            :collapse="collapseMenu"
        >
            <template v-if="chooseHospital === 'doctor'">
                <template v-if="superAdmin !== -1">
                    <!-- <el-submenu index="1" popper-class="collapseMenu">
                        <template slot="title">
                            <i class="iconfont icon-web_lefbar_Hospitalmanagement"></i>
                            <span>医院管理</span>
                        </template>
                        <el-menu-item index="/hospital/hospitalList">医院列表</el-menu-item>
                        <el-menu-item index="/hospital/deptList">科室列表</el-menu-item>
                        <el-menu-item index="/hospital/hospitalGroupList">医生集团列表</el-menu-item>
                    </el-submenu> -->
                    <el-submenu index="2" popper-class="collapseMenu">
                        <template slot="title">
                            <i class="iconfont icon-web_lefbar_Operationmanagement"></i>
                            <span>运营管理</span>
                        </template>
                        <el-menu-item index="/operation/banner">banner管理</el-menu-item>
                        <el-menu-item index="/operation/pushMessage">push群发</el-menu-item>
                        <el-menu-item index="/operation/labelManage">标签管理</el-menu-item>
                        <el-menu-item index="/operation/program">栏目管理</el-menu-item>
                        <el-menu-item index="/operation/consultation">会诊管理</el-menu-item>
                        <el-menu-item index="/operation/moduleManage">自定义模块管理</el-menu-item>
                        <el-menu-item index="/operation/btnManage">首页按钮管理</el-menu-item>
                    </el-submenu>
                    <el-submenu index="3" popper-class="collapseMenu">
                        <template slot="title">
                            <i class="iconfont icon-web_lefbar_management"></i>
                            <span>内容管理</span>
                        </template>
                        <el-menu-item index="/content/expertSeminar">医空间</el-menu-item>
                        <el-menu-item index="/content/videoLibrary">视频库</el-menu-item>
                        <el-menu-item index="/content/videoSet">视频集</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4" popper-class="collapseMenu">
                        <template slot="title">
                            <i class="iconfont icon-web_lefbar_FinancialManagementt"></i>
                            <span>财务管理</span>
                        </template>
                        <el-menu-item index="/financial/orderList">订单管理</el-menu-item>
                        <el-menu-item index="/financial/withdrawList">提现管理</el-menu-item>
                    </el-submenu>

                    <!-- <el-submenu index="5"
                                popper-class="collapseMenu">
                        <template slot="title">
                            <i class="iconfont icon-user1"></i>
                            <span>用户管理</span>
                        </template>
                        <el-menu-item index="/user/registerList">注册管理</el-menu-item>
                        <el-menu-item index="/user/certificationList">认证审核</el-menu-item>
                        <el-menu-item index="/user/userList">用户列表</el-menu-item>
                        <el-menu-item index="/user/feedbackList">反馈统计</el-menu-item>
                    </el-submenu> -->
                </template>
                <el-submenu index="6" popper-class="collapseMenu">
                    <template slot="title">
                        <i class="iconfont icon-user1"></i>
                        <span>咨询专区</span>
                    </template>
                    <el-menu-item index="/counsel/consultingReply">咨询回复</el-menu-item>
                    <el-menu-item index="/counsel/videoManagement">视频管理</el-menu-item>
                    <el-menu-item index="/counsel/commonProblem">常见问题</el-menu-item>
                </el-submenu>
                <el-submenu index="7" popper-class="collapseMenu" v-if="superAdmin !== -1">
                    <template slot="title">
                        <i class="iconfont icon-web_lefbar_management"></i>
                        <span>账户管理</span>
                    </template>
                    <el-menu-item index="/patient/account/accountList">账户列表</el-menu-item>
                </el-submenu>
                <el-submenu index="8" popper-class="collapseMenu" v-if="superAdmin !== -1">
                    <template slot="title">
                        <i class="iconfont icon-jixujiaoyu"></i>
                        <span>继续教育</span>
                    </template>
                    <el-menu-item index="/education/faceRecord">人脸建档记录</el-menu-item>
                    <el-menu-item index="/education/checkRecord">考勤打卡记录</el-menu-item>
                </el-submenu>
            </template>
            <template v-else-if="chooseHospital === 'patient'">
                <!-- <el-submenu index="1"
                            popper-class="collapseMenu">
                    <template slot="title">
                        <i class="iconfont icon-web_lefbar_Hospitalmanagement"></i>
                        <span>用户管理</span>
                    </template>
                    <el-menu-item index="/patient/user/userList">用户列表</el-menu-item>
                </el-submenu> -->
                <el-submenu index="2" popper-class="collapseMenu">
                    <template slot="title">
                        <i class="iconfont icon-web_lefbar_Operationmanagement"></i>
                        <span>内容管理</span>
                    </template>
                    <el-menu-item index="/patient/content/contentList">内容列表</el-menu-item>
                    <el-menu-item index="/patient/content/bannerList">banner列表</el-menu-item>
                </el-submenu>
                <el-submenu index="3" popper-class="collapseMenu" v-if="superAdmin !== -1">
                    <template slot="title">
                        <i class="iconfont icon-web_lefbar_management"></i>
                        <span>账户管理</span>
                    </template>
                    <el-menu-item index="/patient/account/accountList">账户列表</el-menu-item>
                </el-submenu>
            </template>
        </el-menu>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'Sidebar',
    computed: {
        ...mapGetters(['collapseMenu', 'chooseHospital', 'userInfo']),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        superAdmin() {
            if (this.userInfo && this.userInfo.roles) {
                return this.userInfo.roles.findIndex(item => item.roleName === '超级管理员');
            } else {
                return '';
            }
        }
    }
};
</script>

<style lang="scss">
.collapseMenu {
    .el-menu-item {
        height: 40px;
        line-height: 40px;
    }
    .el-menu--popup {
        min-width: 180px;
    }
}

.menu-content {
    width: 48px !important;
    &:not(.el-menu--collapse) {
        width: 180px !important;
    }
    .el-submenu__title,
    .special-menu {
        font-size: 0;
    }
    .menu-text {
        font-size: 14px;
    }
}
.logo-hode {
    .logo-wrap {
        display: none;
    }
    .el-menu-item {
        padding-left: 16px !important;
    }
    .el-submenu .el-submenu__title {
        padding-left: 16px !important;
    }
    .el-tooltip {
        padding-left: 16px !important;
    }
}
</style>
